try {
    Vue.mixin({
        mounted(){
            $('.popupDatepicker').datepick({
                onSelect: function() {
                    if($('#'+$(this).attr("id")).val()!=""){
                        $('#'+$(this).attr("id")).removeClass('is-invalid');
                        $('#'+$(this).attr("id")+'_err').html('');
                    }
                    Fire.$emit('firedatechangefunction',$(this).attr('id'));
                },
                dateFormat: 'dd/mm/yyyy',
            });
        },
        methods: {
            reverseDate(dateData){
                const reverse =
                dateData.split("-").reverse().join("-");
                return reverse;
            },
            reverseDate1(dateData){
                if(dateData!="" && dateData!=undefined){
                    const reverse = dateData.split("-").reverse().join("/");
                    return reverse;
                }
            },
        
            reverseDateTime(dateData){
                if(dateData!="" && dateData!=undefined){
                    reverse = dateData.split(" ")[0].split("-").reverse().join("/")+' '+dateData.split(" ")[1];
                    return reverse;
                }
            },
            
            async getscreenmenus(submenuid){
                if(submenuid!=undefined){
                    localStorage.setItem('screenId', submenuid);
                }
                // alert(submenuid+ ':'+localStorage.getItem('screenId'));
                let uri = 'get_screens_on_submodules/submodule/'+localStorage.getItem('screenId');
                return  axios.get(uri).then(response => { return response.data});
            },

            remove_error(field_id){
                if($('#'+field_id).val()!=""){
                    $('#'+field_id).removeClass('is-invalid');
                    $('#'+field_id+'_err').html('');
                }
            },
        },
    })

} catch (e) {
    console.log('error in main common js: '+e);
}

